
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { getTaskListAchievementProgress } from '@/api/achievements'
import { TaskInfo, AchievementDetails } from '@/entities/tasks'
import CountDownTimer from '@/components/Gamification/CountDownTimer.vue'
import TaskCard from '@/components/Gamification/TaskCard.vue'
import Loading from '@/components/Loading.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'

@Component<TasksList>({
    components: {
        CountDownTimer,
        Loading,
        Typography,
        TaskCard,
    },
})
export default class TasksList extends Vue {
    private taskData!: TaskInfo
    private loading = true

    public async beforeMount() {
        const result = await getTaskListAchievementProgress()
        this.taskData = result.data
        this.loading = false
    }

    private get achievements(): AchievementDetails[] {
        return this.taskData?.achievements
    }
}
